<template>
  <div>
    <el-dialog
      :title="this.value.isCreate ? '添加QQ群' : '修改QQ群'"
      center
      :visible.sync="visible"
      @closed="onClosed"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="700px"
    >
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="120px"
        size="mini"
      >
        <el-form-item label="渠道编号" prop="channelId">
          <el-input v-model="form.channelId"></el-input>
        </el-form-item>
        <el-form-item label="群名称" prop="name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="群号" prop="number">
          <el-input v-model="form.number"></el-input>
        </el-form-item>
        <el-form-item label="顺序" prop="order">
          <el-input v-model="form.order"></el-input>
        </el-form-item>
        <el-form-item label="加群key" prop="addKey">
          <el-input v-model="form.addKey"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" @click="submit()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
const axios = require("axios");
const util = require("../../util");
export default {
  data() {
    return {
      visible: true,
      form: {
        channelId: "",
        name: "",
        number: "",
        order: "",
        addKey: "",
      },
      rules: {
        channelId: [{ required: true, message: " ", trigger: "blur" }],
        name: [{ required: true, message: " ", trigger: "blur" }],
        number: [{ required: true, message: " ", trigger: "blur" }],
        order: [{ required: true, message: " ", trigger: "blur" }],
        addKey: [{ required: true, message: " ", trigger: "blur" }],
      },
    };
  },

  props: {
    value: Object,
  },

  created() {
    if (!this.value.isCreate) {
      this.form.channelId = this.value.oldData.channelId;
      this.form.name = this.value.oldData.name;
      this.form.number = this.value.oldData.number;
      this.form.order = this.value.oldData.order;
      this.form.addKey = this.value.oldData.addKey;
    }
  },

  methods: {
    /**
     * 提交表单
     */
    submit() {
      if (this.value.isCreate) {
        this.addQQGroup();
      } else {
        this.updateQQGroup();
      }
    },

    /**
     * 新增一个QQ群
     */
    addQQGroup() {
      this.$refs["form"].validate(async (valid) => {
        if (!valid) {
          this.$alert("请检查输入", "提示", {
            confirmButtonText: "确定",
          });
          return false;
        }

        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/v1/addQQGroup`,
            {
              channelId: this.form.channelId,
              name: this.form.name,
              number: this.form.number,
              order: this.form.order,
              addKey: this.form.addKey,
            },
            {
              headers: {
                token: util.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message({
            message: "添加失败",
            type: "error",
          });
          return;
        }

        this.$message({
          message: "添加成功",
          type: "success",
        });

        // 关闭当前对话框
        this.visible = false;
      });
    },

    /**
     * 修改QQ群信息
     */
    updateQQGroup() {
      this.$refs["form"].validate(async (valid) => {
        if (!valid) {
          this.$alert("请检查输入", "提示", {
            confirmButtonText: "确定",
          });
          return false;
        }

        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/v1/updateQQGroup`,
            {
              id: this.value.oldData.id,
              channelId: this.form.channelId,
              name: this.form.name,
              number: this.form.number,
              order: this.form.order,
              addKey: this.form.addKey,
            },
            {
              headers: {
                token: util.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message({
            message: "修改失败",
            type: "error",
          });
          return;
        }

        this.$message({
          message: "修改成功",
          type: "success",
        });

        // 关闭当前对话框
        this.visible = false;
      });
    },

    onClosed() {
      // 向父组件抛出事件
      this.$emit("close");
    },
  },
};
</script>